import { useMemo } from "react";
import {
  useRecordContext,
  ReferenceInput,
  AutocompleteInput,
  ReferenceManyField,
  TextField,
  FunctionField,
  ArrayField,
  ArrayFieldProps,
  SingleFieldList,
  ChipField,
  Pagination,
  TextInput,
} from "react-admin";
import { EditableDatagrid, RowForm } from "@react-admin/ra-editable-datagrid";
import { Link } from "react-router-dom";

const SORT_BY_NAME = { field: "name", order: "ASC" } as const;

function GroupsEdit() {
  const GROUPS_FILTER = useMemo(() => {
    return { isGroup: true };
  }, []);

  const record = useRecordContext();
  if (!record) return null;

  const DataGridForm = useMemo<JSX.Element>(() => {
    return (
      <RowForm>
        <TextInput readOnly source="userId" defaultValue={record.id} />

        <ReferenceInput
          source="groupId"
          reference="user"
          filter={GROUPS_FILTER}
          sort={SORT_BY_NAME}
          alwaysOn
          allowEmpty
        >
          <AutocompleteInput label="Group Name" optionText="commonName" />
        </ReferenceInput>
      </RowForm>
    );
  }, [record.id]);

  return (
    <ReferenceManyField
      reference="usersXGroups"
      target="userId"
      label="Group"
      perPage={25}
    >
      <EditableDatagrid
        createForm={DataGridForm}
        editForm={DataGridForm}
        bulkActionButtons={false}
      >
        <TextField source="id" sortable={false} />

        <FunctionField
          label="Group Name"
          sortable={false}
          render={(record: any) => (
            <Link to={`/user/${record.groupId}`}>
              <TextField
                label="Group Name"
                source="group.commonName"
                sortable={false}
              />
            </Link>
          )}
        />
        <FunctionField
          label="Group Organization"
          sortable={false}
          render={(record: any) =>
            !!record.group.organization ? (
              <Link to={`/organization/${record.group.organization.id}`}>
                <TextField
                  label="Group Organization"
                  source="group.organization.name"
                  sortable={false}
                />
              </Link>
            ) : (
              <TextField
                label="Group Organization"
                source="group.organization.name"
                sortable={false}
              />
            )
          }
        />

        <ArrayField
          {...({ source: "group.roles", label: "Group Flags", sortable: false } as ArrayFieldProps)}
        >
          <SingleFieldList>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ArrayField>

        <ArrayField
          {...({ source: "group.sets", label: "Group Sets", sortable: false } as ArrayFieldProps)}
        >
          <SingleFieldList>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ArrayField>
      </EditableDatagrid>
      <Pagination />
    </ReferenceManyField>
  );
}

export default GroupsEdit;
